import { Medal, MedalStar, OceanProtocol } from "iconsax-react";

export const singleSectionCategories = ["Nickname", "E-mail", "Bio", "Dates", "Keywords", "Relationship"];
export const categoriesNotToView = ["Name", "Availability", "Relationship", "Emergency"];
export const categoriesWithShowCard = ["Name", "Nickname", "Profession"];
export const categoriesWithDefaultAction = ["Website", "Call", "Socials", "Addresses", "E-mail"];
export const categoriesForBasic = ["Name", "Nickname", "Call", "E-mail", "Addresses", "Medical"];
export const defaultableLabels = [
    "First Name",
    "Middle Name",
    "Last Name",
    "Name Prefix",
    "Name Suffix",
    "Job Title",
    "Department",
    "Company",
    "Number",
    "E-mail Address",
    "Nickname",
    "Location",
    "Field",
    "Social Account",
    "Url"
];
export const defaultableCategories = [
    "Socials",
    "Nickname",
    "Website",
    "Name",
    "Addresses",
    "Call",
    "Profession",
    "E-mail"
];

export const memberships = [
    {
        _id: "1",
        "name": "Basic",
        "title": "Starter / Personal",
        "price": 0.0,
        "features": [
            "Unlimeted connections",
            "1 Basic Card",
            "1 Information Language",
            "Publish Basic Card for free",
            "Rewards Program"
        ],
        "info": "Share your basic information with your family & friends and keep them n' Sync with our starter package for basic personal use."
    },
    {
        _id: "2",
        "name": "Standard",
        "title": "Personal / Socializer",
        "price": 0.0,
        "features": [
            "Ads free",
            "Unlimeted connections",
            "1 Basic Card",
            "1 Standard  Card",
            "2 Information Language",
            "Publish Basic Card for free",
            "Rewards Program - Higher multipler"
        ],
        "info": "Grow up your social network with our advanced package for personal use Which allow you to share more personal and social accounts information."
    },
    {
        _id: "3",
        "name": "Premium",
        "title": "Socializer / Professional",
        "price": 3.99,
        "features": [
            "Ads free",
            "Unlimeted connections",
            "1 Basic Card",
            "2 Standard  Card",
            "2 Information Language",
            "Publish Basic Card for free",
            "Rewards Program - Highest multipler"
        ],
        "info": "Grow up your social network with our advanced package for personal use Which allow you to share more personal and social accounts information."
    }
];

export const icons = {
    Basic: Medal,
    Standard: MedalStar,
    Premium: OceanProtocol
};